import React from 'react'
import { getFile } from 'sr/utils/api/getFile'

type Attachment = { name?: string; url: string }

type Props = {
  items: Attachment[]
  label?: string
}

export const AttachmentList: React.FC<Props> = ({ items = [], label = 'Documents' }) => {
  const pdfs = (items || []).filter((a) => /\.pdf$/i.test(String(a?.url || '')))
  if (pdfs.length === 0) return null

  const openDoc = async (att: Attachment) => {
    try {
      const isFull = /^https?:\/\//i.test(String(att?.url || ''))
      const url = isFull ? att.url : await getFile(att.url, 'url')
      if (url) window.open(String(url), '_blank')
    } catch {}
  }

  return (
    <div className="bg-white rounded-xl mt-4">
      <div className="flex items-center gap-2 mb-3">
        <p className="text-sm font-semibold text-gray-700">{label}</p>
        <span className="bg-blue-50 text-blue-600 text-xs px-2 py-1 rounded-full font-medium">
          {pdfs.length} {pdfs.length === 1 ? 'file' : 'files'}
        </span>
      </div>
      
      <div className="space-y-3">
        {pdfs.map((d, i) => {
          const name = d?.name || (String(d?.url || '').split('/').pop() || `Document ${i + 1}`)
          return (
            <div
              key={`${name}-${i}`}
              className="flex items-center justify-between p-3 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-lg transition-all duration-200 group"
            >
              <div className="flex items-center gap-3 min-w-0 flex-1">
                <div className="flex-shrink-0 w-8 h-8 bg-red-50 rounded-lg flex items-center justify-center">
                  <svg className="w-4 h-4 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" clipRule="evenodd" />
                  </svg>
                </div>
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-medium text-gray-900 truncate">{name}</p>
                  <p className="text-xs text-gray-500 mt-0.5">PDF Document</p>
                </div>
              </div>
              
              <button
                onClick={() => openDoc(d)}
                className="flex items-center gap-2 px-3 py-2 bg-white border border-[#e7339f] rounded-lg text-sm font-medium text-[#e7339f] transition-all duration-200 group-hover:shadow-sm flex-shrink-0 ml-3"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                Download
              </button>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default AttachmentList